// extracted by mini-css-extract-plugin
export default {"i_frame_full_screen":"stp-viewer_i_frame_full_screen__WP155"};